import React from 'react'
import { FC } from 'react'
import useBookmark from 'hooks/useBookmark'
import { Tool } from '__generated__/api-types-and-hooks'
import BookMarkIcon from 'components/Common/SvgIcons/BookmarkIcon'
import GradientCircleNotchIcon from 'components/Common/SvgIcons/GradientCircleNotchIcon'

interface IToolBookmark {
  tool: Tool
}

const ToolBookmark: FC<IToolBookmark> = ({ tool }) => {
  const { handleClick, isBookmarkingInProgress } = useBookmark(tool)
  return (
    <span className="flex gap-1 items-center text-primary text-xs font-[650] relative">
      {tool.isBookmarked ? 'Bookmarked' : 'Bookmark'}
      <div className="absolute top-5">
        {isBookmarkingInProgress && <GradientCircleNotchIcon width="30" height="30" />}
      </div>
      <span onClick={() => handleClick(tool)}>
        <BookMarkIcon
          className={`${tool.isBookmarked ? 'fill-[#5E06B9]' : ''} ${
            isBookmarkingInProgress ? 'pointer-events-none cursor-not-allowed' : ''
          }`}
        />
      </span>
    </span>
  )
}

export default ToolBookmark
